import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import {
  TABLE,
  THEAD,
  TBODY,
  TH,
  TR,
  TD,
} from 'zignal-landscape/lib/Table';
import EditIcon from 'zignal-landscape/lib/Icon/EditIcon';
import SortAscendingIcon from 'zignal-landscape/lib/Icon/SortAscendingIcon';
import SortDescendingIcon from 'zignal-landscape/lib/Icon/SortDescendingIcon';
import SortNoneIcon from 'zignal-landscape/lib/Icon/SortNoneIcon';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import themeable from 'zignal-landscape/lib/themeable';

const InternalAdminsTable = ({
  styles,
  users = [],
  sortOrder,
  sortBy,
  accountMap,
  userMap,
  handleSortChange
}) => {

  const getHeaderIcon = (headerName) => {
    if (headerName === sortBy) {
      return sortOrder === 'asc'
        ? (<SortAscendingIcon />)
        : (<SortDescendingIcon />);
    }
    return (<SortNoneIcon />);
  };

  const getAccountName = (accountId) => {
    if (!accountMap || !accountId) {return accountId;}
    const account = accountMap[accountId];
    return account && account.name ? account.name : accountId;
  };

  const getCreatedByName = (userId) => {
    if (!userMap || !userId) {return userId;}
    const user = userMap[userId];
    return user && user.username ? user.username : userId;
  };

  const usersRows = map(users, (user) => {
    const { id, username, email, account, additionalAccounts, createdBy, createdAt, fullAccountAccessEnabled } = user;
    const allAccounts = [account, ...(additionalAccounts || [])];
    const accountNames = allAccounts.map(getAccountName);
    const fullAccessStatus = fullAccountAccessEnabled ? 'Enabled' : '';
    const lineHeightStyle = {};
    if (accountNames.length >= 3) {
      lineHeightStyle.lineHeight = '20px';
    } else if (accountNames.length === 2) {
      lineHeightStyle.lineHeight = '30px';
    }

    return (
      <TR key={id} id={id}>
        <TD>{username}</TD>
        <TD>{email}</TD>
        <TD style={{minWidth: '300px'}}><div style={lineHeightStyle}>{accountNames.map((name, index) => <div key={index}>{name}</div>)}</div></TD>
        <TD style={{minWidth: '100px'}}>{getCreatedByName(createdBy)}</TD>
        <TD style={{whiteSpace: 'nowrap'}}>{createdAt}</TD>
        <TD style={{minWidth: '160px'}}>{fullAccessStatus}</TD>
        <TD className={styles.actionsCell}>
          <ToolTip position="top" tooltipText="Edit">
            <a
              href={`/settings/users/edit/${id}/`}
              onClick={(e) => {
                if (!e.metaKey && !e.ctrlKey) {
                  e.preventDefault();
                  window.location.pathname = `/settings/users/edit/${id}/`;
                }
              }}
              className={styles.edit}
            >
              <EditIcon />
            </a>
          </ToolTip>
        </TD>
      </TR>
    );
  });

  return (
    <>
      {users && users.length > 0
        ? (
          <div className={styles.InternalAdminsTableWrapper}>
            <TABLE>
              <THEAD>
                <TR>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('username')}>
                      Username {getHeaderIcon('username')}
                    </div>
                  </TH>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('email')}>
                      Email {getHeaderIcon('email')}
                    </div>
                  </TH>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('accounts')}>
                      Account(s) {getHeaderIcon('accounts')}
                    </div>
                  </TH>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('createdBy')}>
                      CreatedBy {getHeaderIcon('createdBy')}
                    </div>
                  </TH>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('createdAt')}>
                      CreatedDate {getHeaderIcon('createdAt')}
                    </div>
                  </TH>
                  <TH>
                    <div className={styles.tableHeader} onClick={() => handleSortChange('fullAccountAccessEnabled')}>
                      FullAccountAccess {getHeaderIcon('fullAccountAccessEnabled')}
                    </div>
                  </TH>
                  <TH>Actions</TH>
                </TR>
              </THEAD>
              <TBODY>
                {usersRows}
              </TBODY>
            </TABLE>
          </div>
        ) : (
          <div className={styles.noRecords}>
            No Internal Admins to show
          </div>
        )
      }
    </>
  );
};

InternalAdminsTable.propTypes = {
  styles: PropTypes.object.isRequired,
  users: PropTypes.array,
  sortOrder: PropTypes.string,
  sortBy: PropTypes.string,
  accountMap: PropTypes.object,
  userMap: PropTypes.object,
  handleSortChange: PropTypes.func,
};

export default themeable(InternalAdminsTable);
